import {
	includedPropList,
	includedT2PropList,
} from "../../../pages/activityBuilder/modules/largeFisheries/largeFisheries";
import type {
	LargeFisheriesResponse,
	ModuleFull,
} from "../../../pages/activityBuilder/modules/largeFisheries/largeFisheriesTypes";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

// Define constants for the module
const MODULE_TYPE = "LargeFisheries";
const TAG: TagTypes = "LargeFisheries";
const TAG_DEFAULTS: TagTypes = "LargeFisheriesDefaults";
const ENDPOINT = FEModulesObj[FEModules.LargeFisheries].path;

const t1PercentageProps = ["ice_preserved_catch_pc", "refrigerant_pc"];

const transformResponse = (response: LargeFisheriesResponse) => transformModuleResponse<LargeFisheriesResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList,
	percentageProps: t1PercentageProps
})

const largeFisheryApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicLargeFisheryApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	percentageProps: t1PercentageProps,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, LargeFisheriesResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
})

export const {
	useGetLargeFisheriesQuery,
	useGetLargeFisheriesDefaultsQuery
} = largeFisheryApiSlice;

export const {
	useGetLargeFisheriesQuery: usePublicGetLargeFisheriesQuery,
	useGetLargeFisheriesDefaultsQuery: usePublicGetLargeFisheriesDefaultsQuery,
} = publicLargeFisheryApiSlice;

export const {
	useUpdateLargeFisheriesMutation,
} = mutationApiSlice;
